<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h2 id="dejanos">Ingresá el número de chasis (VIN) de tu Volkswagen, para conocer si se encuentra alcanzado por alguna campaña de Recall.</h2>
        <p @click="mostrarInfo">¿Dónde encuentro el número de chasis (VIN) o patente? </p>
      </div>
    </div>
    <chequeo></chequeo>
    <hr />
    <div id="contacto">
      <form autocomplete="off" @submit.prevent="enviarForm()" id="contact_form">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="intro-copy" style="padding-left: 0;">Dejanos tus datos, para que podamos contactarte en caso de que tu vehículo se encuentre alcanzado por un recall futuro.</h3>
          </div>
          <span class="separador"></span>
          <div
            class="form-group col-md-4"
            :class="{'has-error' : errors.has('name'), 'has-success' : fields.name && fields.name.valid }"
          >
            <float-label>
              <input
                type="text"
                name="name"
                id="name"
                class="form-control efecto"
                placeholder="Nombre*"
                v-model="user.nombre"
                v-validate="'required|alpha_spaces|max:255'"
                data-vv-as="Nombre"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('name')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('name') }}</div>
          </div>
          <div
            class="form-group col-md-4"
            :class="{ 'has-error': errors.has('lastname'), 'has-success' : fields.lastname && fields.lastname.valid }"
          >
            <float-label>
              <input
                type="text"
                name="lastname"
                id="lastname"
                class="form-control efecto"
                placeholder="Apellido*"
                v-model="user.apellido"
                v-validate="'required|alpha_spaces|max:255'"
                data-vv-as="Apellido"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('lastname')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('lastname') }}</div>
          </div>
          <div
            class="form-group col-md-4"
            :class="{ 'has-error': errors.has('dni'), 'has-success' : fields.dni && fields.dni.valid }"
          >
            <float-label>
              <input
                type="text"
                name="dni"
                id="dni"
                class="form-control efecto"
                placeholder="DNI*"
                v-model="user.dni"
                v-validate="'required|numeric|max:12'"
                data-vv-as="DNI"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('dni')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('dni') }}</div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-md-4"
            :class="{ 'has-error': errors.has('email'), 'has-success' : fields.email && fields.email.valid  }"
          >
            <float-label>
              <input
                type="email"
                name="email"
                id="email"
                class="form-control efecto"
                placeholder="Email*"
                v-model="user.email"
                v-validate="'required|email'"
                ref="email"
                data-vv-as="Email"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('email')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('email') }}</div>
          </div>
          <div
            class="form-group col-md-4"
            :class="{ 'has-error': errors.has('email_confirm'), 'has-success' : fields.email_confirm && fields.email_confirm.valid  }"
          >
            <float-label>
              <input
                type="email"
                name="email_confirm"
                id="email_confirm"
                class="form-control efecto"
                placeholder="Verificar email*"
                v-validate="'email|confirmed:email'"
                ref="confirmed"
                data-vv-as="Verificar email"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('email_confirm')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('email_confirm') }}</div>
          </div>
          <div
            class="form-group col-md-4"
            :class="{ 'has-error': errors.has('telefono'), 'has-success' : fields.telefono && fields.telefono.valid }"
          >
            <float-label>
              <input
                type="text"
                name="telefono"
                id="telefono"
                class="form-control efecto"
                placeholder="Teléfono*"
                v-model="user.telefono"
                v-validate="'required|numeric|max:14'"
                data-vv-as="Teléfono"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('telefono')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('telefono') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6" :class="{ 'has-error': errors.has('vin'), 'has-success' : fields.vin }">
            <float-label>
              <input
                type="text"
                name="vin"
                id="vin"
                class="form-control efecto"
                placeholder="VIN*"
                v-model="user.vin"
                v-validate="'required|alpha_num|max:20'"
                data-vv-as="VIN"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('vin')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('vin') }}</div>
          </div>
          <div class="form-group col-md-6" :class="{ 'has-error': errors.has('patente'), 'has-success' : fields.patente }">
            <float-label>
              <input
                type="text"
                name="patente"
                id="patente_"
                class="form-control efecto"
                placeholder="Patente*"
                v-model="user.patente"
                v-validate="'required'" 
                data-vv-as="Patente"
              >
              <span class="focus-border"></span>
            </float-label>
            <div
              v-if="errors.has('patente')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('patente') }}</div>
          </div>
        </div>
        <div class="row">
          <span class="separador3"></span>
          <div class="col-xs-12">
            <div class="checkboxes">
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    id="newsletter"
                    name="newsletter"
                    data-vv-as="Newsletter"
                    v-model="user.newsletter"
                  > <span class="checkbox-custom"></span><small>Acepto Términos y Condiciones. **</small>
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <button style="margin-left: -2px; margin-top: 2em;" type="submit" class="btn btn-default btn-primary" :disabled="cargando || errors.any() || !user.newsletter"><span v-text="cargando ? 'Enviando' : 'Enviar'"></span></button>
          </div>
          <div class="col-xs-12">
            <hr style="border-color: transparent;" />
            <p style="padding: 0 5px;"><a href="https://www.volkswagen.com.ar/es/postventa/recall-listado-completo.html" target="_blank">Ver listado completo de recalls</a></p>
          </div>
          <div class="col-xs-12">
            <h3 v-if="enviado" style="color: #001e50;">¡Muchas gracias por tu colaboración!</h3>
          </div>
          <div class="col-xs-12" style="padding-top: 5em;">
            <p><small>* Campos obligatorios</small></p>
            <p><small>** Declaro conocer y aceptar que los datos aquí suministrados será conservados por Volkswagen Argentina S.A., con la finalidad de incorporar mis datos a su base de clientes y poder brindar correctamente el servicio de garantía y postventa, asi como también, para contestar consultas, aplicar sugerencias, enviar respuestas, realizar encuestas, prestar servicios de atención al cliente, y utilizar los datos ingresados para fines publicitarios, de marketing y para promociones propias, o de servicios y productos de terceros.</small></p>
            <p><small>Presto mi consentimiento para que mis datos sean tratados a esos fines tanto por Volkswagen Argentina S.A. como por otras empresas del grupo Volkswagen y/o a terceras empresas vinculadas al mismo por acuerdos comerciales, incluyendo prestadores de Servicios locales o en cualquier jurisdicción extranjera.</small></p>
            <p><small>Como responsable de bases de datos, Volkswagen Argentina S.A. garantiza que los procesos internos propios de las bases de datos cumplen con las obligaciones legales de seguridad y confidencialidad impuestas por la Ley No 25.326 de Protección de Datos Personales y que se asegura el acceso, actualización, supresión o rectificación de los datos por parte de su titular (artículo 14 y 15 de la Ley 25.326).</small></p>
            <p><small>Conforme la Disposición DNPDP N° 10/08: El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326.</small></p>
            <p><small>La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</small></p>
            <p><small>*** Aviso válido para la República Argentina, únicamente para vehículos afectados por el recall de airbags Takata. Consultar unidades afectadas en www.volkswagen.com.ar, sección “Recall e Informativos”. Bonificación válida por un año desde la entrega del voucher. Incluye cambio de aceite, filtro y mano de obra. No es canjeable por otras prestaciones. Promoción válida únicamente para vehículos afectados que realicen la verificación a partir del 30 de mayo de 2022. Para más información consulte en www.volkswagen.com.ar o comuníquese con el Centro de Atención al Cliente al 0800-888-8338 o por e-mail a atencioncliente@vw.com.ar”.</small></p>
          </div>
        </div>
      </form>
    </div>
    <noscript>
      <img src="https://ad.doubleclick.net/ddm/activity/src=6703934;type=invmedia;cat=postv001;u1=[SegmentContext/PartnerSegmentCode];u2=[EncryptedUserId];u3=[PH3];u4=[PH4];u5=[PH5];u6=[PH6];u7=[PH7];u8=[PH8];u9=[PH9];u10=[PH10];u11=[Autoahorro_URL];u12=[PageName];u13=[VisitIntent];u14=[Model];u15=[ModelType];u16=[isCurious];u17=[Color];u18=[CarConfStartIntent];u19=[CarConfEndIntent];u20=[DealerStarted];u21=[DealerComplete];u22=[DealerSelectionIntent];u23=[DealerLocation];u24=[ModelIntent];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>
    </noscript>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import swal from "sweetalert2";
import FloatLabel from "vue-float-label/components/FloatLabel";
import Chequeo from "./Chequeo.vue";
import Slide from "./Slide.vue";

export default {
  name: "Form",
  components: {
    FloatLabel, Chequeo, Slide
  },
  data() {
    return {
      user: {
        nombre: "",
        apellido: "",
        dni: "",
        telefono: "",
        vin: "",
        email: "",
        patente: "",
        newsletter: false,
      },
      enviado: false,
      cargando: false,
      chasis: "",
      patente: "",
      submitted: false,
      img: "../assets/tarjeta.png",
      FORM_URL:
        window.location.hostname === "localhost"
          ? "http://eficiencia.test/api/form"
          : "https://eficiencia-energetica.vwcontenidos.com.ar/api/form"
    };
  },
  methods: {
    scrollAForm() {
      const el = document.getElementById('contact_form');
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    mostrarInfo() {
      swal({
        title: false,
        icon: "info",
        html: document.getElementById("indicaciones").innerHTML,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        showConfirmButton: false,
        width: "100%",
        animation: false
      });
    },
    dispararEventos() {
      // console.log('agregar gtag y fbq');
      window.gtag("event", "conversion", {
        send_to: "AW-880716059/zIavCKSq14cCEJvS-qMD"
      });
      window.fbq("track", "Recall");
      window.gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u1': '[SegmentContext\/PartnerSegmentCode]',
        'u10': '[PH10]',
        'u11': '[Autoahorro_URL]',
        'u12': '[PageName]',
        'u13': '[VisitIntent]',
        'u14': '[Model]',
        'u15': '[ModelType]',
        'u16': '[isCurious]',
        'u17': '[Color]',
        'u18': '[CarConfStartIntent]',
        'u19': '[CarConfEndIntent]',
        'u2': '[EncryptedUserId]',
        'u20': '[DealerStarted]',
        'u21': '[DealerComplete]',
        'u22': '[DealerSelectionIntent]',
        'u23': '[DealerLocation]',
        'u24': '[ModelIntent]',
        'u3': '[PH3]',
        'u4': '[PH4]',
        'u5': '[PH5]',
        'u6': '[PH6]',
        'u7': '[PH7]',
        'u8': '[PH8]',
        'u9': '[PH9]',
        'send_to': 'DC-6703934/invmedia/postv001+standard'
      });
    },
    enviarForm() {
      this.cargando = true;
      this.submitted = true;
      // this.$validator.validateAll(scope).then(valid => {
      this.$validator.validate().then(valid => {
        if (valid) {
          let form_data = new FormData();
          let item = this.user;
          for (let key in item) {
            form_data.append(key, item[key]);
          }
          axios
            .post(this.FORM_URL, form_data, {
              headers: {
                "Content-type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {
              this.cargando = false;
              if (res.status === 200) {
                this.dispararEventos()
                this.enviado = true
                setTimeout(function(){
                  document.getElementById("contact_form").reset()
                }, 500)
              } else {
                swal({
                  type: "error",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  text:
                    "Ocurrió un error, por favor intente nuevamente más tarde."
                });
              }
            })
            .catch(() => {
              this.cargando = false;
              swal({
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                text:
                  "Ocurrió un error, por favor intente nuevamente más tarde."
              });
            });
        } else {
          this.cargando = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  transition: all 0.3s ease;
}

.text-danger {
  padding: 0.5em;
  border-radius: 4px;
}

textarea {
  min-width: 100%;
  max-width: 100%;
}

button:focus {
  outline: none !important;
}

#yo {
  text-align: center;
  @media(max-width: 767px) {
    text-align: left;
    margin-bottom: 2em;
  }
  p {
    margin: -10px 0 15px;
    line-height: 3.3em;
    border: 1px solid #001e50;
    display: inline-block;
    width: 3.5em;
    border-radius: 50%;
    height: 3.5em;
    color: #001e50;
    @media(max-width: 769px) {
      margin: 15px 0 0;
      font-size: 1.25em;
    }
  }
}

form {
  padding: 0 5px;
  @media (max-width: 767px) {
    padding: 0 5%;
  }
  & > .row.margin {
    margin-bottom: 6.7em;
  }
  & > .row:not(.margin) {
    // margin-bottom: 0.8em;
  }
  h3 {
    font-size: 2.3em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 400;
    letter-spacing: -0.04em;
    margin-bottom: 1.55em;
  }
  input,
  select,
  textarea {
    color: #001e50;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.2em;
    padding: 0;
    letter-spacing: -0.035em;
    @media(max-width: 767px) {
      font-size: 1.4em;
      letter-spacing: 0.005em;
    }
    &:hover,
    &:focus {
      box-shadow: none;
    }
    &:focus {
      outline: none;
      border-color: #9b9b9b;
    }
    &.efecto ~ .focus-border {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: #001e50;
      transition: 0.4s;
    }
    &.efecto:focus ~ .focus-border {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }
  select {
    -webkit-appearance: none;
    appearance: none;
  }
  textarea {
    resize: none;
    margin-top: 0.3em;
    height: 1.6em;
  }
  .separador,
  .separador2 {
    display: block;
    height: 1.4em;
    @media(max-width: 767px) {
      height: 0.6em;
    }
  }
  .separador2 {
    height: 7em;
  }
  #legal {
    margin-top: 6.7em;
    font-size: 1.4em;
    line-height: 1.3em;
    letter-spacing: -0.022em;
    font-weight: 200;
  }
  .checkbox {
    color: #001e50;
    font-size: 1.4em;
    margin-top: 2.1em;
    @media (max-width: 669px) {
      font-size: 1.8em;
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    small {
      line-height: 1em;
    }
    label {
      padding-left: 2em;
      vertical-align: text-bottom;
      line-height: 0.6em;
      letter-spacing: -0.007em;
      @media (max-width: 1441px) {
        line-height: 1.4em;
      }
      @media (max-width: 669px) {
        line-height: 0.3em;
      }
    }
    .checkbox-custom {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 24px;
      width: 24px;
      background-color: transparent;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      border: 2px solid #001e50;
      border-radius: 0;
    }
    input:checked ~ .checkbox-custom {
      background-color: #001e50;
      -webkit-transform: rotate(0deg) scale(1);
      -ms-transform: rotate(0deg) scale(1);
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 2px solid #001e50;
    }
    .checkbox-custom::after {
      position: absolute;
      content: "";
      left: 12px;
      top: 12px;
      height: 0px;
      width: 0px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(0deg) scale(0);
      -ms-transform: rotate(0deg) scale(0);
      transform: rotate(0deg) scale(0);
      opacity: 1;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }
    input:checked ~ .checkbox-custom::after {
      -webkit-transform: rotate(45deg) scale(1);
      -ms-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      opacity: 1;
      left: 8px;
      top: 3px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .btn.btn-primary {
    border-radius: 22px;
    margin: 7px 14px;
    font-size: 1.2em;
    padding: 0.4em 5.4em 0.6em;
    letter-spacing: -0.04em;
    color: #fff;
    background: #001e50;
    border: 1px solid #fff;
    &:focus,
    &:active {
      box-shadow: none;
      outline: none;
    }
    @media (max-width: 767px) {
      display: block;
      width: 94%;
      font-size: 1.4em;
      padding: 0.7em;
      margin: 1.3em 3.5%;
    }
  }
  .relative {
    position: relative;
  }
  .has-success .form-control,
  .has-success .form-control:focus,
  .has-error .form-control,
  .has-error .form-control:focus {
    box-shadow: none;
    border-color: #9b9b9b;
  }

  .text-danger {
    background: white;
    color: #dd2c00;
    padding: 2px;
  }
}
#revision {
  font-size: 1.3em;
  margin: 3.7em 5px 6.7em;
  letter-spacing: 0.007em;
  @media(max-width: 767px) {
    font-size: 1.1em;
    margin: 1em 4%;
    letter-spacing: -0.01em;
    color: #001e50;
  }
}
</style>
